export default {
  path: '/app',
  component: () => import('@/views/app/the-layout.vue'),
  children: [
    {
      path: '/:pathMatch(.*)*',
      component: () => import('@/views/errors/error-404.vue'),
      meta: { title: 'Halaman Tidak Ditemukan' },
    },
    {
      path: '/akses-ditolak',
      name: 'forbidden',
      component: () => import('@/views/errors/error-403.vue'),
      meta: { title: 'Akses Ditolak' },
    },
  ],
}
